import Vue from "vue";
import VueRouter from "vue-router";
import Blog from "../views/Blog.vue";
import { getOriginConfig } from "@/utils/autoweb";
import CustomServer from "@/utils/customServer";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Blog",
    component: Blog,
  },
];

const router = new VueRouter({
  routes,
  mode: "hash",
});
let hasGetOriginConfig = false;
router.beforeEach(async (to, from, next) => {
  if (!hasGetOriginConfig) {
    const res = await getOriginConfig();
    store.dispatch("setWebInfo", res.data);
    hasGetOriginConfig = true;
    return next();
  } else {
    return next();
  }
});
export default router;
